<template>
    <select>
        <slot></slot>
        <option v-for="option in options" :value="option.id">{{ option.text }}</option>
    </select>
</template>

<script>
    import $ from "jquery";
    import select2 from 'select2/dist/js/select2.full.js';
    import es from 'select2/src/js/select2/i18n/es.js'
    import 'select2/dist/css/select2.css';

    $.fn.select2.defaults.set('language', es);

    export default {
        name: 'Select2',
        props: {
            options: Array,
            value: String | Number,
            configOptions: {
                type: Object,
                default () {
                    return {}
                }
            },
            hideArrowDisabled: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            configOptionsFinal() {
                let configOptions = _.cloneDeep(this.configOptions);
                if (this.hideArrowDisabled) {
                    configOptions.containerCssClass = 'select2-hide-arrow';
                }
                return configOptions;
            }
        },
        mounted: function () {
            var vm = this;
            $(this.$el)
                .select2(this.configOptionsFinal)
                .val(this.value)
                .trigger('change')
                .on('select2:select', function () {
                    vm.$emit('input', this.value);
                    vm.$emit('change', this.value);
                });
        },
        watch: {
            value: function (value) {
                this.resetValue();
            },
            options: function (options) {
                this.resetValue();
            },
            configOptionsFinal: function (configOptions) {
                $(this.$el)
                    .select2(configOptions)
                    .val(this.value)
                    .trigger('change');
            }
        },
        methods: {
            resetValue: function () {
                let vm = this;
                this.$nextTick(function () {
                    $(vm.$el)
                        .val(vm.value)
                        .trigger('change')
                });
            }
        },
        destroyed: function () {
            $(this.$el).off().select2('destroy')
        }
    }
</script>

<style>
    .select2-container--disabled .select2-hide-arrow .select2-selection__arrow b{
        display:none !important;
    }
</style>
